import React, { Component } from "react";
import {
    Row,
    Col,
    Input,
    Button,
    Modal,
    ModalBody,
    ModalHeader
} from "reactstrap";

import Registry from "../../../Utils/Registry";

import OperationsFleetBaseForm from "../../Operations/Fleet/BaseForm";
import TYSwitch from '../../TYSwitch';

import Vars from "../../../Utils/Variables";

const { energies } = Vars;

class CreateOrderFormVehicles extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.loadCompanyVehicles = this.loadCompanyVehicles.bind(this);
        this.toggleVehicle = this.toggleVehicle.bind(this);
        this.toggleAllVehicles = this.toggleAllVehicles.bind(this);
        this.validateStep = this.validateStep.bind(this);
        this.toggleAddVehicleForm = this.toggleAddVehicleForm.bind(this);
        this.vehicleAdded = this.vehicleAdded.bind(this);

        if(this.props.state)
            this.state = this.props.state;
        else{
            this.state = {
                loading: false,
                vehicles: [],
                categories: [],
                gas_list: [],
                vehicles_toggled: {},
                toggle_all: false,
                toggled_count: 0,
                filter_category: "",
                filter_sub_energy: "",
                filter_search: "",
                filter_energy: "",
                search_text: "",
                add_vehicle_modal_open: false
            };
        }
    }

    handleFilterChange(e, key){
        if(this.state.hasOwnProperty(key)){
            let state = this.state;
            state[key] = e.target.value;
            if(key === "filter_energy")
                state["filter_sub_energy"] = "";
            
            this.setState(state, this.checkToggleAllStatus);
        }
    }

    checkToggleAllStatus = () => this.setState({
        toggle_all: this.state.vehicles
            .filter(this.checkFilters)
            .reduce((acc, { id }) => acc && this.state.vehicles_toggled[id], true)
    });

    getGasList(){
        this.api.get("/gas?available_to=B2B")
            .then(results => this.setState({gas_list: results.gas}))
            .catch(_ => { });
    }

    componentDidMount(){
        this.getGasList();
        if(!this.state.vehicles.length)
            this.loadCompanyVehicles();
    }

    loadCompanyVehicles(resetSelection=true){
        this.setState({
            loading: true,
            vehicles: []
        });

        this.api.get("/fleet?type=business")
            .then(results => {
                let vehicles_toggled = {};
                let categories = [];
                
                for(let v of results.fleet){
                    vehicles_toggled[v.id] = false;
                    if(!categories.includes(v.category))
                        categories.push(v.category);
                }
                
                this.setState({
                    loading: false,
                    vehicles: results.fleet,
                    vehicles_toggled: resetSelection ? vehicles_toggled : this.state.vehicles_toggled,
                    toggled_count: resetSelection ? 0 : this.state.toggled_count,
                    categories
                }, this.checkToggleAllStatus);
            })
            .catch(_ => this.setState({
                loading: false
            }));
    }

    toggleVehicle(vehicle){
        let stats = this.state.vehicles_toggled;
        let count = this.state.toggled_count;
        
        if(stats.hasOwnProperty(vehicle.id)){
            let a = stats[vehicle.id];
            stats[vehicle.id] = !a;
            if(stats[vehicle.id])
                count++;
            else
                count--;
        }

        this.setState({
            toggled_count: count,
            vehicles_toggled: stats
        }, () => {
            this.checkToggleAllStatus();
            this.props.onVehicleToggle(vehicle, stats[vehicle.id])
        });
    }

    toggleAllVehicles(){
        this.setState({toggle_all: !this.state.toggle_all}, () => {
            let stats = this.state.vehicles_toggled;
            let count = this.state.toggled_count;
            
            for(let vehicle of this.state.vehicles){
                if(this.checkFilters(vehicle)){
                    if(stats.hasOwnProperty(vehicle.id)){
                        const old_state = stats[vehicle.id];
                        if(old_state !== this.state.toggle_all){
                            if(!old_state)
                                count++;
                            else 
                                count--;
                        }
                        stats[vehicle.id] = this.state.toggle_all;
                    }
                }
            }

            this.setState({
                toggled_count: count,
                vehicles_toggled: stats
            });
        });
    }

    validateStep(){
        if(this.state.toggled_count){
            let vehicles = [];

            for(let v of this.state.vehicles){
                if(this.state.vehicles_toggled.hasOwnProperty(v.id) && this.state.vehicles_toggled[v.id])
                    vehicles.push(v);
            }

            this.props.onValidateStep(vehicles, this.state);
        }
    }

    vehicleAdded(){
        this.setState({add_vehicle_modal_open: !this.state.add_vehicle_modal_open}, () => this.loadCompanyVehicles(false));
    }

    toggleAddVehicleForm(){
        this.setState({add_vehicle_modal_open: !this.state.add_vehicle_modal_open});
    }

    checkFilters = vehicle => {
        const { filter_search, filter_energy, filter_sub_energy, filter_category } = this.state;

        // Energy filter
        if(filter_energy && vehicle.energy_type !== parseInt(filter_energy))
            return false; 
            
        // Sub energy filter
        if(filter_sub_energy && 
            (((filter_energy === "0" || filter_energy === "") && vehicle.gas_id !== filter_sub_energy)
            || (filter_energy === "1" && vehicle.energy_sub_type !== parseInt(filter_sub_energy))))
            return false;
    
        // Category filter
        if(filter_category && vehicle.category !== filter_category)
            return false;

        // Search filter
        if(filter_search 
            && !vehicle.plate.toLowerCase().includes(filter_search.toLowerCase()) 
            && !vehicle.description.toLowerCase().includes(filter_search.toLowerCase())
            && !vehicle.color.toLowerCase().includes(filter_search.toLowerCase()))
            return false;

        return true;
    } 

    render(){
        const { filter_search, filter_energy, filter_sub_energy, filter_category } = this.state;

        return (
            <div className="blue_dark">
                <h2 className="ty-subtitle">
                    S&eacute;l&eacute;ctionner les v&eacute;hicules &agrave; ravitailler
                </h2>

                <div className="ty-block pad-0">
                    <div className="pad-20 border-b-1-gray">
                        <Row>
                            <Col md="6">
                                <Input
                                    type="text"
                                    value={filter_search}
                                    placeholder="Modèle, plaque d'immatriculation, ..."
                                    onChange={e => {this.handleFilterChange(e, "filter_search")}}
                                />
                            </Col>
                            <Col md="6">
                                <Input type="select"
                                    value={filter_category}
                                    onChange={e => {this.handleFilterChange(e, "filter_category")}}
                                >
                                    <option value="">Flotte ...</option>
                                    {
                                        this.state.categories.map((category, i) => {
                                            return <option key={"cat-" + i} value={category}>
                                                { category }
                                            </option>;
                                        })
                                    }
                                </Input>
                            </Col>
                        </Row>
                        <Row className="marg-t-15">
                            <Col md="6">
                                <Input
                                    type="select"
                                    value={filter_energy}
                                    onChange={e => this.handleFilterChange(e, "filter_energy")}
                                >
                                    <option value="">Energie ...</option>
                                    { energies.map(({ value, label }, i) => <option key={"energy-"+i} value={value}>{label}</option>) }
                                </Input>
                            </Col>
                            <Col md="6">
                                <Input
                                    type="select"
                                    value={filter_sub_energy}
                                    onChange={e => {this.handleFilterChange(e, "filter_sub_energy")}}
                                >
                                    <option value="">{ energies[filter_energy] ? energies[filter_energy].label : "" } ...</option>
                                    { 
                                        filter_energy === "1" ?
                                            energies[filter_energy].subTypes.map(({value, label}) => <option key={"gas-"+value} value={value}>{label}</option>)
                                        :
                                            this.state.gas_list.map(({id, name}) => <option key={"gas-"+id} value={id}>{name}</option>)
                                    }
                                </Input>
                            </Col>
                        </Row>
                    </div>

                    <div className="pad-20">
                        <div>
                            { this.state.toggled_count } v&eacute;hicule(s) s&eacute;lectionn&eacute;(s)
                            <div className="float-right">
                                <TYSwitch name="toggle-all" checked={this.state.toggle_all} onChange={this.toggleAllVehicles} />
                            </div>
                        </div>
                        {
                            this.state.loading ?
                                <div className="center pad-20">
                                    <i className="icon icon-loading animated spin infinite f-20 blue_dark"> </i>
                                </div>
                                :
                                <ul className="list-unstyled marg-t-20 maxh-250 overflow-scroll-y pad-b-10">
                                    {
                                        this.state.vehicles.map((vehicle, i) => {
                                            if(!this.checkFilters(vehicle))
                                                return;

                                            return <li key={i} className={
                                                        "marg-b-10 rounded"
                                                        + " border-1-" + (this.state.vehicles_toggled[vehicle.id] ? "blue" : "gray")
                                                    } style={{
                                                        borderLeftColor: vehicle.gas_color,
                                                        borderLeftWidth: 5
                                                    }}>
                                                    <table className="wp-100 blue_dark">
                                                        <tbody>
                                                            <tr>
                                                                <td className="_w-50 bg-gray_light border-r-1-gray center">
                                                                    <i className="icon icon-car gray_dark" aria-hidden="true"> </i>
                                                                </td>
                                                                <td className="pad-l-10">
                                                                    {vehicle.description + " " + vehicle.color}<br />
                                                                    {vehicle.plate}
                                                                </td>
                                                                <td className="_w-60">
                                                                    <TYSwitch
                                                                        name={"vehicle-" + i}
                                                                        checked={this.state.vehicles_toggled[vehicle.id]}
                                                                        onChange={(e) => {this.toggleVehicle(vehicle)}}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </li>;
                                        })
                                    }
                                </ul>
                        }
                        <div className="right">
                            <span className="blue underline pointer" onClick={this.toggleAddVehicleForm}>Ajouter un nouveau v&eacute;hicule</span>
                        </div>
                    </div>
                </div>

                <Modal size="lg" isOpen={this.state.add_vehicle_modal_open} toggle={this.toggleAddVehicleForm}>
                    <ModalHeader toggle={this.toggleAddVehicleForm}>Ajouter un vehicule</ModalHeader>
                    <ModalBody>
                        <OperationsFleetBaseForm
                            newVehicleAdded={this.vehicleAdded}
                            showTitle={false}
                            tyBlock={false}
                            gas_list={ this.state.gas_list }
                        />
                    </ModalBody>
                </Modal>

                <div className="center marg-t-20">
                    <Button
                        className="text-uppercase"
                        color="primary"
                        disabled={!this.state.toggled_count}
                        onClick={this.validateStep}
                    >
                        Valider
                    </Button>
                </div>
            </div>
        );
    }
}

CreateOrderFormVehicles.defaultProps = {
    onVehicleToggle: (vehicle, toggled) => {},
    onValidateStep: (vehicles, state) => {},
    state: null
};

export default CreateOrderFormVehicles;



// WEBPACK FOOTER //
// ./src/components/CreateOrder/Form/Vehicles.js